import * as Models from "@gigalot/data-models";
import lodash from "lodash";
import moment from "moment";

function withdrawalExpiry(animalOrEvents: Models.Animal | Models.AnimalEvent[]): number | undefined {
  const events = Array.isArray(animalOrEvents) ? animalOrEvents : animalOrEvents.events;
  const validEvents = events.filter((event) => event.time !== undefined && event.withdrawal !== undefined);
  const latestWithdrawal = lodash.maxBy(
    validEvents,
    (event) => (event.time as number) + moment.duration(event.withdrawal as number, "days").asMilliseconds()
  );

  if (latestWithdrawal?.time === undefined || latestWithdrawal.withdrawal === undefined) return undefined;
  return latestWithdrawal.time + moment.duration(latestWithdrawal.withdrawal, "days").asMilliseconds();
}

export function withdrawalDaysFromToday(animal: Models.Animal): number | undefined {
  const expiry = withdrawalExpiry(animal);
  if (expiry === undefined) return undefined;

  const today = moment(Date.now()).startOf("day");
  return moment(expiry).startOf("day").diff(today, "days");
}
